var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgAlert = function SvgAlert(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 36,
    viewBox: "0 0 43 36",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.4094 2.52965C19.783 0.299685 23.2168 0.299688 24.5904 2.52965L41.5879 30.1255C42.9615 32.3554 41.2445 35.1429 38.4974 35.1429H4.50235C1.75527 35.1429 0.038349 32.3554 1.41189 30.1255L18.4094 2.52965Z",
    stroke: "#FF8C00",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2286 22.5103H21.7713C21.9933 22.5103 22.2153 22.2979 22.2399 22.0854L22.9553 14.6222V11.6476C22.9553 11.382 22.7333 11.1429 22.4866 11.1429H20.5133C20.2667 11.1429 20.0447 11.382 20.0447 11.6476V14.6753L20.76 22.0854C20.7846 22.2979 21.0066 22.5103 21.2286 22.5103ZM19.7857 27.3104C19.7857 28.3196 20.575 29.1429 21.4876 29.1429C22.4496 29.1429 23.2143 28.3196 23.2143 27.3104C23.2143 26.2745 22.4496 25.4512 21.4876 25.4512C20.575 25.4512 19.7857 26.2745 19.7857 27.3104Z",
    fill: "#FF8C00"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAlert, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/alert.025808d4.svg";
export { ForwardRef as ReactComponent };